export default "__VITE_ASSET__BZMmiLkV__"